import { render, staticRenderFns } from "./CasesFilter.vue?vue&type=template&id=106f0579"
import script from "./CasesFilter.vue?vue&type=script&lang=js"
export * from "./CasesFilter.vue?vue&type=script&lang=js"
import style0 from "./CasesFilter.vue?vue&type=style&index=0&id=106f0579&prod&lang=scss"
import style1 from "./CasesFilter.vue?vue&type=style&index=1&id=106f0579&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports